module.exports = __webpack_public_path__ + "static/media/mi-logo-final_Black.5618906d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mi-logo-final_Black.png
// module id = 1486
// module chunks = 0